import React from 'react';
import PropTypes from 'prop-types';
import { COVER_AND_REPORT_LAYOUT } from '../../constants/reportLayouts';
import ReportLayoutPage from './ReportLayoutPage'


const CoverAndReportLayout = ({ match }) => (
  <ReportLayoutPage
    layout={COVER_AND_REPORT_LAYOUT}
    reportType={match.params.type}
    companyId={match.params.companyId}
    withCoverLetter={true}
    withEndOfReport={true}
    withAttachment={true}
  />
);

CoverAndReportLayout.propTypes = {
  match: PropTypes.object
};

export default CoverAndReportLayout;


// WEBPACK FOOTER //
// src/components/reportLayout/CoverAndReportLayout.jsx